import apiClient from "../../utils/apiClient";

export const getOrderHistoryData = async (params) => {
  const response = await apiClient.get("/api/v1/order-history", { params });
  return response;
};
